module.exports = __webpack_public_path__ + "static/media/1717125674690-min.0045d685.jpg";